import api from "./api";

export async function getAllTransactions(page = 1, filters = {}) {
    const params = {
        page,
        ...filters
    };
    const res = await api.get("/admin/transactions", { params });
    return res.data.data; 
}
export async function AddTowallet(payload) {
    const res = await api.post("/admin/transactions/increase-wallet", payload);
    return res.data.data;
}

export async function RemoveFromwallet(payload) {
    const res = await api.post("/admin/transactions/decrease-wallet", payload);
    return res.data.data;
}